/* There can only ever be one instance of wrapped help text appearing at the end of the string:
Expected format: "some text{help}message inside help text{/help}"
com.riadalabs.jira.plugins.insight.services.util.ErrorMessageTranslatorImpl in jsm-cmdb-monolith */

const wrappedHelpRegex = /{help}(.*?){\/help}/;

const transformHelpError = (
	textWithWrappedHelp: string,
	match: RegExpMatchArray | null,
): string => {
	if (!match || match.length < 2) {
		return textWithWrappedHelp;
	}
	return textWithWrappedHelp.replace(
		match[0],
		(match?.index ?? 0) > 0 ? `. ${match[1]}` : match[1],
	);
};

export const getWrappedHelpText = (possiblyHasWrappedHelpText: string) =>
	possiblyHasWrappedHelpText.match(wrappedHelpRegex);

export const formatHelpError = (possiblyHasWrappedHelpText: string) => {
	const matchedHelpText = getWrappedHelpText(possiblyHasWrappedHelpText);
	if (matchedHelpText) {
		return transformHelpError(possiblyHasWrappedHelpText, matchedHelpText);
	}
	return possiblyHasWrappedHelpText;
};
